import axios from 'axios';
import { API } from '../../constants';
import _ from 'lodash';

const createAction = name => ({
    GET_TAX_ADDRESS_PENDING: `${name}_GET_TAX_ADDRESS_PENDING`,
    GET_TAX_ADDRESS_SUCCESS: `${name}_GET_TAX_ADDRESS_SUCCESS`,
    GET_TAX_ADDRESS_FAILED: `${name}_GET_TAX_ADDRESS_FAILED`,

    OPEN_DIALOG_CREATE_TAX_ADDRESS: `${name}_OPEN_DIALOG_CREATE_TAX_ADDRESS`,
    CLOSE_DIALOG_CREATE_TAX_ADDRESS: `${name}_CLOSE_DIALOG_CREATE_TAX_ADDRESS`,

    CREATE_TAX_ADDRESS_PENDING: `${name}_CREATE_TAX_ADDRESS_PENDING`,
    CREATE_TAX_ADDRESS_SUCCESS: `${name}_CREATE_TAX_ADDRESS_SUCCESS`,
    CREATE_TAX_ADDRESS_FAILED: `${name}_CREATE_TAX_ADDRESS_FAILED`,

    EDIT_ADDRESS_PENDING: `${name}_EDIT_ADDRESS_PENDING`,
    EDIT_ADDRESS_SUCCESS: `${name}_EDIT_ADDRESS_SUCCESS`,
    EDIT_ADDRESS_FAILED: `${name}_EDIT_ADDRESS_FAILED`,

    UPDATE_TAX_ADDRESS_PENDING: `${name}_UPDATE_TAX_ADDRESS_PENDING`,
    UPDATE_TAX_ADDRESS_SUCCESS: `${name}_UPDATE_TAX_ADDRESS_SUCCESS`,
    UPDATE_TAX_ADDRESS_FAILED: `${name}_UPDATE_TAX_ADDRESS_FAILED`,

    DELETE_ADDRESS_PENDING: `${name}_DELETE_ADDRESS_PENDING`,
    DELETE_ADDRESS_SUCCESS: `${name}_DELETE_ADDRESS_SUCCESS`,
    DELETE_ADDRESS_FAILED: `${name}_DELETE_ADDRESS_FAILED`,

    DESTROY_ADDRESS_SUCCESS: `${name}_DESTROY_ADDRESS_SUCCESS`,

    SET_AS_DEFAULT_PENDING: `${name}_SET_AS_DEFAULT_PENDING`,
    SET_AS_DEFAULT_SUCCESS: `${name}_SET_AS_DEFAULT_SUCCESS`,
    SET_AS_DEFAULT_FAILED: `${name}_SET_AS_DEFAULT_FAILED`,

    OPEN_DIALOG_EDIT_ADDRESS: `${name}_OPEN_DIALOG_EDIT_ADDRESS`,
    CLOSE_DIALOG_EDIT_ADDRESS: `${name}_CLOSE_DIALOG_EDIT_ADDRESS`,

    OPEN_DIALOG_CONFIRM_DELETE: `${name}_OPEN_DIALOG_CONFIRM_DELETE`,
    CLOSE_DIALOG_CONFIRM_DELETE: `${name}_CLOSE_DIALOG_CONFIRM_DELETE`,

    OPEN_DIALOG_NOT_ALLOW_DELETE: `${name}_OPEN_DIALOG_NOT_ALLOW_DELETE`,
    CLOSE_DIALOG_NOT_ALLOW_DELETE: `${name}_CLOSE_DIALOG_NOT_ALLOW_DELETE`
});

export const TAX_ADDRESS = createAction('TAX_ADDRESS');

export const GetTaxAddress = () => async (dispatch, getState) => {
    dispatch({ type: TAX_ADDRESS.GET_TAX_ADDRESS_PENDING });

    try {
        const { login, language } = getState();
        const params = {
            customerId: login.firebaseAuth.uid
        };

        const result = await axios
            .get(
                API.GET_TAX_ADDRESS,
                { params },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': language.currentLanguage
                    }
                }
            )
            .then(res => res.data)
            .catch(error => Promise.reject(error));
        
        dispatch({
            type: TAX_ADDRESS.GET_TAX_ADDRESS_SUCCESS,
            payload: result || []
        });
    } catch (error) {
        dispatch({
            type: TAX_ADDRESS.GET_TAX_ADDRESS_FAILED,
            error
        });
    }
};

////// CREATE
export const OpenDialogCreateTaxAddress = () => dispatch => {
    dispatch({ type: TAX_ADDRESS.OPEN_DIALOG_CREATE_TAX_ADDRESS });
};

export const CloseDialogCreateTaxAddress = () => dispatch => {
    dispatch({ type: TAX_ADDRESS.CLOSE_DIALOG_CREATE_TAX_ADDRESS });
};

export const CreateTaxAddress = data => async (dispatch, getState) => {
    dispatch({ type: TAX_ADDRESS.CREATE_TAX_ADDRESS_PENDING });
    try {
        const { login, language } = getState();
        const { firebaseAuth } = login;
        const province = JSON.parse(data.values.province);
        const district = JSON.parse(data.values.district);
        const subDistrict = JSON.parse(data.values.subDistrict);

        const taxAddress = {
            name: data.values.name,
            lastName: data.values.lastName,
            taxId: data.values.taxId,
            phoneNumber: data.values.phoneNumber,
            email: data.values.email,
            address: data.values.address,
            province: province.PROVINCE_NAME,
            district: district.DISTRICT_NAME,
            subDistrict: subDistrict.SUB_DISTRICT_NAME,
            zipCode: `${data.values.zipCode}`,
            isDefault: data.isDefault
        };

        const params = {
            customerId: firebaseAuth.uid,
            address: JSON.stringify([taxAddress])
        };

        const result = await axios
            .post(API.CREATE_TAX_ADDRESS, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': language.currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));
        
        if (result) {
            dispatch({
                type: TAX_ADDRESS.CREATE_TAX_ADDRESS_SUCCESS,
                payload: [taxAddress]
            });
        }
    } catch (error) {
        dispatch({
            type: TAX_ADDRESS.CREATE_TAX_ADDRESS_FAILED,
            error
        });
    }
};

export const AddOtherTaxInvoiceAddress = form => async (dispatch, getState) => {
    dispatch({ type: TAX_ADDRESS.UPDATE_TAX_ADDRESS_PENDING });
    try {
        const { login, language, taxaddress } = getState();
        const { firebaseAuth } = login;
        let oldTaxInvoiceAddress = taxaddress.data;
        const province = JSON.parse(form.values.province);
        const district = JSON.parse(form.values.district);
        const subDistrict = JSON.parse(form.values.subDistrict);

        const addNewTaxInvoiceAddress = {
            name: form.values.name,
            lastName: form.values.lastName,
            taxId: form.values.taxId,
            phoneNumber: form.values.phoneNumber,
            email: form.values.email,
            address: form.values.address,
            province: province.PROVINCE_NAME,
            district: district.DISTRICT_NAME,
            subDistrict: subDistrict.SUB_DISTRICT_NAME,
            zipCode: `${form.values.zipCode}`,
            isDefault: form.isDefault
        };

        if (form.isDefault === 'Y') {
            //modify isDefault in address already exists
            oldTaxInvoiceAddress.forEach(data => {
                data.isDefault = 'N';
                return data;
            });
        }

        oldTaxInvoiceAddress = [...oldTaxInvoiceAddress, addNewTaxInvoiceAddress];
        let address = _.orderBy(oldTaxInvoiceAddress, ['isDefault'], ['desc']);
        const params = {
            customerId: firebaseAuth.uid,
            address: JSON.stringify(address)
        };

        const result = await axios
            .put(API.UPDATE_TAX_ADDRESS, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': language.currentLanguage
                }
            })
            .then(res => res.status)
            .catch(error => Promise.reject(error));
        
        if (result) {
            dispatch({
                type: TAX_ADDRESS.UPDATE_TAX_ADDRESS_SUCCESS,
                payload: address
            });
        }
    } catch (error) {
        dispatch({ type: TAX_ADDRESS.UPDATE_TAX_ADDRESS_FAILED });
    }
};

export const EditTaxAddress = values => async (dispatch, getState) => {
    dispatch({ type: TAX_ADDRESS.EDIT_ADDRESS_PENDING });
    try {
        const { login, language, taxaddress } = getState();
        const { data, editSelected } = taxaddress;
        const { firebaseAuth } = login;
        const rawAddressData = data;

        const province = JSON.parse(values.province);
        const district = JSON.parse(values.district);
        const subDistrict = JSON.parse(values.subDistrict);
        rawAddressData[editSelected.index].name = values.name;
        rawAddressData[editSelected.index].lastName = values.lastName;
        rawAddressData[editSelected.index].taxId = values.taxId;
        rawAddressData[editSelected.index].phoneNumber = values.phoneNumber;
        rawAddressData[editSelected.index].email = values.email;
        rawAddressData[editSelected.index].address = values.address;
        rawAddressData[editSelected.index].province = province.PROVINCE_NAME;
        rawAddressData[editSelected.index].district = district.DISTRICT_NAME;
        rawAddressData[editSelected.index].subDistrict = subDistrict.SUB_DISTRICT_NAME;
        rawAddressData[editSelected.index].zipCode = `${values.zipCode}`;
        rawAddressData[editSelected.index].isDefault = values.isDefault;

        let address = _.orderBy(rawAddressData, ['isDefault'], ['desc']);

        const params = {
            customerId: firebaseAuth.uid,
            address: JSON.stringify(address)
        };
        const result = await axios
            .put(API.UPDATE_TAX_ADDRESS, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': language.currentLanguage
                }
            })
            .then(res => res.status)
            .catch(error => Promise.reject(error));
        
        if (result) {
            dispatch({
                type: TAX_ADDRESS.EDIT_ADDRESS_SUCCESS,
                payload: address
            });
        }
    } catch (error) {
        dispatch({
            type: TAX_ADDRESS.EDIT_ADDRESS_FAILED,
            error
        });
    }
};

export const DeleteTaxAddress = () => async (dispatch, getState) => {
    dispatch({ type: TAX_ADDRESS.DELETE_ADDRESS_PENDING });
    try {
        const { login, language, taxaddress } = getState();
        const { data, deleteSelected } = taxaddress;
        const { firebaseAuth } = login;
        if (data.length > 1 && deleteSelected.value.isDefault === 'Y') {
            dispatch({ type: TAX_ADDRESS.OPEN_DIALOG_NOT_ALLOW_DELETE });
        } else {
            let filtered = _.filter(data, (taxaddress, index) => index !== deleteSelected.index);

            if (filtered.length === 0) {
                const params = {
                    customerId: firebaseAuth.uid
                };
                await axios
                    .delete(
                        API.DELETE_TAX_ADDRESS,
                        { params },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': language.currentLanguage
                            }
                        }
                    )
                    .then(res => res.data)
                    .catch(error => Promise.reject(error));
                dispatch({ type: TAX_ADDRESS.DESTROY_ADDRESS_SUCCESS });
            } else {
                let address = _.orderBy(filtered, ['isDefault'], ['desc']);
                const params = {
                    customerId: firebaseAuth.uid,
                    address: JSON.stringify(address)
                };

                const result = await axios
                    .put(API.UPDATE_TAX_ADDRESS, params, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': language.currentLanguage
                        }
                    })
                    .then(res => res.status)
                    .catch(error => Promise.reject(error));
                if (result) {
                    dispatch({
                        type: TAX_ADDRESS.DELETE_ADDRESS_SUCCESS,
                        payload: address
                    });
                }
            }
        }
    } catch (error) {
        dispatch({
            type: TAX_ADDRESS.DELETE_ADDRESS_FAILED,
            error
        });
    }
};

export const SetTaxAddressAsDefault = index => async (dispatch, getState) => {
    dispatch({ type: TAX_ADDRESS.SET_AS_DEFAULT_PENDING });
    try {
        const { login, language, taxaddress } = getState();
        const { firebaseAuth } = login;
        let oldAddress = taxaddress.data;

        oldAddress.forEach((data, i) => {
            i === index ? (data.isDefault = 'Y') : (data.isDefault = 'N');
            return data;
        });

        const params = {
            customerId: firebaseAuth.uid,
            address: JSON.stringify(_.orderBy(oldAddress, ['isDefault'], ['desc']))
        };

        const result = await axios
            .put(API.UPDATE_TAX_ADDRESS, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': language.currentLanguage
                }
            })
            .then(res => res.status)
            .catch(error => Promise.reject(error));
        
        if (result) {
            dispatch({
                type: TAX_ADDRESS.SET_AS_DEFAULT_SUCCESS,
                payload: _.orderBy(oldAddress, ['isDefault'], ['desc'])
            });
        }
    } catch (error) {
        dispatch({
            type: TAX_ADDRESS.SET_AS_DEFAULT_FAILED,
            error
        });
    }
};

////// EDIT ADDRESS
export const OpenDialogEditTaxAddress = (index, value) => dispatch => {
    dispatch({
        type: TAX_ADDRESS.OPEN_DIALOG_EDIT_ADDRESS,
        payload: { index, value }
    });
};

export const CloseDialogEditTaxAddress = () => dispatch => {
    dispatch({ type: TAX_ADDRESS.CLOSE_DIALOG_EDIT_ADDRESS });
};

////// CONFIRM DELETE
export const OpenDialogConfirmDeleteTaxAddress = (index, value) => dispatch => {
    dispatch({
        type: TAX_ADDRESS.OPEN_DIALOG_CONFIRM_DELETE,
        payload: { index, value }
    });
};

export const CloseDialogConfirmDeleteTaxAddress = () => dispatch => {
    dispatch({ type: TAX_ADDRESS.CLOSE_DIALOG_CONFIRM_DELETE });
};

////// NOT ALLOW DELETE
export const OpenDialogNotAllowDeleteTaxAddress = () => dispatch => {
    dispatch({ type: TAX_ADDRESS.OPEN_DIALOG_NOT_ALLOW_DELETE });
};

export const CloseDialogNotAllowDeleteTaxAddress = () => dispatch => {
    dispatch({ type: TAX_ADDRESS.CLOSE_DIALOG_NOT_ALLOW_DELETE });
};
